export abstract class FillableModel {
    public fill(json: any) {
        for (let field in json) {
            if (this.hasOwnProperty(field)) {
                this[field] = json[field];
            }
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/shared/models/fillable.model.ts